import { Space, Typography } from 'antd';

import styled, { StyledProp, css } from '@/styled';

interface EmptyStateProps extends StyledProp {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  extra?: React.ReactNode;
}

const EmptyState = ({ icon, title, description, extra, ...rest }: EmptyStateProps) => {
  return (
    <Space {...rest} direction='vertical' size={24}>
      {icon}
      <Typography.Title level={4}>{title}</Typography.Title>
      <Typography.Paragraph>{description}</Typography.Paragraph>
      {extra}
    </Space>
  );
};

export default styled(EmptyState)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: ${theme.space.pxToRem(24)};
    padding-top: 15vh;
    text-align: center;

    ${theme.breakpoints.down('sm')} {
      padding-top: 0;
      margin-top: ${theme.space.pxToRem(48)};
    }

    svg {
      fill: ${theme.colorText};
      font-size: ${theme.space.pxToRem(64)};
    }

    .ant-typography {
      margin-bottom: 0;
    }
  `}
`;
